export const formatDate = (dateObject: Date | undefined): string => {
  if (dateObject === undefined) {
    return "N/A";
  }

  // Use UTC timezone to prevent date shifting due to local timezone conversion
  // This ensures the date displays as stored (e.g., end dates at end-of-day don't shift to next day)
  return dateObject.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
};
